export class Brand {
    private id: number;
    private description: string;

    constructor(id: number = 0, description: string = "") {
        this.id = id;
        this.description = description;
    }

    public get _id(): number {
        return this.id;
    }

    public set _id(value: number) {
        this.id = value;
    }

    public get _description(): string {
        return this.description;
    }

    public set _description(value: string) {
        this.description = value;
    }
}